import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ShoppingCart } from 'lucide-react';
import GlobalHeader from '@/components/GlobalHeader';
import ShoppingTabs from '@/components/shopping/ShoppingTabs';
import { toast } from 'sonner';

import ActiveListsTab from '@/components/shopping/ActiveListsTab';
import FavoritesTab from '@/components/shopping/FavoritesTab';
import PeopleTab from '@/components/shopping/PeopleTab';
import EventsTab from '@/components/shopping/EventsTab';
import HistoryTab from '@/components/shopping/HistoryTab';
import TemplatesTab from '@/components/shopping/TemplatesTab';

// Shopping module green theme tokens
const SHOPPING_THEME = {
  primary: '#86EFAC',
  light: '#DCFCE7',
  lighter: '#F0FDF4',
  dark: '#166534',
  icon: '#22C55E',
  surface: '#FAFDF7',
};

const ShoppingPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('lists');
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = useCallback(async () => {
    setRefreshKey(prev => prev + 1);
    toast.success('Data refreshed');
  }, []);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'lists':
        return <ActiveListsTab key={`lists-${refreshKey}`} />;
      case 'favorites':
        return <FavoritesTab key={`favorites-${refreshKey}`} />;
      case 'people':
        return <PeopleTab key={`people-${refreshKey}`} />;
      case 'events':
        return <EventsTab key={`events-${refreshKey}`} />;
      case 'history':
        return <HistoryTab key={`history-${refreshKey}`} />;
      case 'templates':
        return <TemplatesTab key={`templates-${refreshKey}`} />;
      default:
        return <ActiveListsTab key={`lists-${refreshKey}`} />;
    }
  };

  return (
    <div 
      className="min-h-screen"
      style={{ backgroundColor: SHOPPING_THEME.surface }}
    >
      <GlobalHeader
        icon={ShoppingCart}
        iconBgColor={SHOPPING_THEME.light}
        iconColor="text-green-700"
        title="Shopping"
        subtitle="Remember what you need"
        onRefresh={handleRefresh}
      />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <ShoppingTabs
          activeTab={activeTab}
          onTabChange={setActiveTab}
        >
          {renderTabContent()}
        </ShoppingTabs>
      </main>
    </div>
  );
};

export default ShoppingPage;
